import { PageKey, Pages } from "~/models/Page"

export const PAGES: Pages = {
  [PageKey.Customer]: {
    label: "お客様情報", pcNone: false, pcNoneText: null
  },
  [PageKey.Recommend]: {
    label: "商品選択", pcNone: false, pcNoneText: null
  },
  [PageKey.EdRecommend]: {
    label: "商品選択（電帳）", pcNone: false, pcNoneText: null
  },
  [PageKey.PpRecommend]: {
    label: "プライスボード", pcNone: false, pcNoneText: null
  },
  [PageKey.MpRecommend]: {
    label: "マーケットプレイス", pcNone: false, pcNoneText: null
  },
  [PageKey.PayRecommend]: {
    label: "BLPay", pcNone: false, pcNoneText: null
  },
  [PageKey.Contract]: {
    label: "契約数選択", pcNone: false, pcNoneText: null
  },
  [PageKey.BasicPack]: {
    label: "基本パック", pcNone: false, pcNoneText: null
  },
  [PageKey.AddPack]: {
    label: "追加", pcNone: true, pcNoneText: "ライセンス"
  },
  [PageKey.Option]: {
    label: "オプション", pcNone: false, pcNoneText: null
  },
  [PageKey.Database]: {
    label: "データ", pcNone: true, pcNoneText: "ベース"
  },
  [PageKey.MaService]: {
    label: "メンテナンス", pcNone: true, pcNoneText: "サービス"
  },
  [PageKey.InstSup]: {
    label: "導入支援", pcNone: false, pcNoneText: null
  },
  [PageKey.Estimate]: {
    label: "合計金額", pcNone: false, pcNoneText: null
  },
  [PageKey.SimpleEstimate]: {
    label: "合計金額", pcNone: false, pcNoneText: null
  }
} as const

